var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fundo-accordion" },
    [
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsCdbRdb,
                    cor: "#2679ED",
                    evolucao: _vm.evolucao.produto.cdbRdb,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsCdbRdb.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsCdbRdb.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsCdbRdb.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  monthLabel: _vm.monthLabel,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsCdbRdb.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsLciLca,
                    cor: "#2679ED",
                    evolucao: _vm.evolucao.produto.lciLca,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsLciLca.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsLciLca.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsLciLca.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsLciLca.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsCriCra,
                    cor: "#29BD1A",
                    evolucao: _vm.evolucao.produto.criCra,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsCriCra.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsCriCra.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsCriCra.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsCriCra.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsDebentures,
                    cor: "#29BD1A",
                    evolucao: _vm.evolucao.produto.debentures,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsDebentures.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsDebentures.items, function(
                              ativo
                            ) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsDebentures.items, function(
                              ativo
                            ) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsDebentures.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsTitulosPublicos,
                    cor: "#FAA90F",
                    evolucao: _vm.evolucao.produto.titulos,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsTitulosPublicos.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsTitulosPublicos.items, function(
                              ativo
                            ) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsTitulosPublicos.items, function(
                              ativo
                            ) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsTitulosPublicos.items, function(
                        ativo
                      ) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsFundosInvestimento,
                    cor: "#FAA90F",
                    evolucao: _vm.evolucao.produto.fundosInvestimento,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsFundosInvestimento.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.dessertsFundosInvestimento.items,
                              function(ativo) {
                                return _c("card1", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  attrs: {
                                    dataRecieved: ativo,
                                    bound: _vm.bound
                                  },
                                  on: {
                                    cardClicked: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                })
                              }
                            ),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(
                              _vm.dessertsFundosInvestimento.items,
                              function(ativo) {
                                return _c("card2", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  attrs: {
                                    dataRecieved: ativo,
                                    bound: _vm.bound
                                  },
                                  on: {
                                    cardClicked: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                })
                              }
                            ),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsFundosInvestimento.items, function(
                        ativo
                      ) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsPrevidencia,
                    cor: "#FAA90F",
                    evolucao: _vm.evolucao.produto.previdencia,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsPrevidencia.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsPrevidencia.items, function(
                              ativo
                            ) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsPrevidencia.items, function(
                              ativo
                            ) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsPrevidencia.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsAcoes,
                    cor: "#FA5807",
                    evolucao: _vm.evolucao.produto.acoes,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsAcoes.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsAcoes.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsAcoes.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsAcoes.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsFundosImobiliarios,
                    cor: "#FA5807",
                    evolucao: _vm.evolucao.produto.fundosImobiliarios,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsFundosImobiliarios.items.length == 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.dessertsFundosImobiliarios.items,
                              function(ativo) {
                                return _c("card1", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  attrs: {
                                    dataRecieved: ativo,
                                    bound: _vm.bound
                                  },
                                  on: {
                                    cardClicked: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                })
                              }
                            ),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(
                              _vm.dessertsFundosImobiliarios.items,
                              function(ativo) {
                                return _c("card2", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showItem(ativo),
                                      expression: "showItem(ativo)"
                                    }
                                  ],
                                  key: ativo.title,
                                  attrs: {
                                    dataRecieved: ativo,
                                    bound: _vm.bound
                                  },
                                  on: {
                                    cardClicked: function($event) {
                                      return _vm.goCarteira(ativo)
                                    }
                                  }
                                })
                              }
                            ),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsFundosImobiliarios.items, function(
                        ativo
                      ) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("Accordion", {
        staticClass: "accordion",
        attrs: { cor: "none" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("Header", {
                  attrs: {
                    switchView: _vm.switchVisualizacao,
                    item: _vm.dessertsOutros,
                    cor: "#FA5807",
                    evolucao: _vm.evolucao.produto.outros,
                    saldototal: _vm.evolucao.total.saldo,
                    bound: _vm.bound
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.dessertsOutros.items.length === 0
                  ? _c("div", { staticClass: "text-center pa-4" }, [
                      _vm._v(
                        " Nenhum investimento encontrado para este tipo de produto "
                      )
                    ])
                  : _vm._e(),
                _vm.telaMobile
                  ? _c("div", [
                      !_vm.switchVisualizacao
                        ? _c(
                            "div",
                            _vm._l(_vm.dessertsOutros.items, function(ativo) {
                              return _c("card1", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.dessertsOutros.items, function(ativo) {
                              return _c("card2", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showItem(ativo),
                                    expression: "showItem(ativo)"
                                  }
                                ],
                                key: ativo.title,
                                attrs: {
                                  dataRecieved: ativo,
                                  bound: _vm.bound
                                },
                                on: {
                                  cardClicked: function($event) {
                                    return _vm.goCarteira(ativo)
                                  }
                                }
                              })
                            }),
                            1
                          )
                    ])
                  : _vm._e(),
                !_vm.telaMobile
                  ? _c(
                      "div",
                      _vm._l(_vm.dessertsOutros.items, function(ativo) {
                        return _c(
                          "div",
                          {
                            key: ativo.title,
                            staticClass: "row-expansion",
                            on: {
                              click: function($event) {
                                return _vm.goCarteira(ativo)
                              }
                            }
                          },
                          [
                            _c("Body", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showItem(ativo),
                                  expression: "showItem(ativo)"
                                }
                              ],
                              attrs: {
                                switchView: _vm.switchVisualizacao,
                                ativo: ativo,
                                bound: _vm.bound
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }